import { render } from "./QimenPredict.vue?vue&type=template&id=4d3cc38f&scoped=true"
import script from "./QimenPredict.vue?vue&type=script&lang=js"
export * from "./QimenPredict.vue?vue&type=script&lang=js"

import "./QimenPredict.vue?vue&type=style&index=0&id=4d3cc38f&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3cc38f"]])

export default __exports__